var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 431,
    viewBox: "0 0 585 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 339L-2.38419e-05 339",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 133L-2.38419e-05 133",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 244L-2.38419e-05 244",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 38L-2.38419e-05 38",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 358L-2.38419e-05 358",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 152L-2.38419e-05 152",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 263L-2.38419e-05 263",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 57L-2.38419e-05 57",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 377L-2.38419e-05 377",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 171L-2.38419e-05 171",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 282L-2.38419e-05 282",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 76L-2.38419e-05 76",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 396L-2.38419e-05 396",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 190L-2.38419e-05 190",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 301L-2.38419e-05 301",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 95L-2.38419e-05 95",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 415L-2.38419e-05 415",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 209L-2.38419e-05 209",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 225L-2.38419e-05 225",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 19L-2.38419e-05 19",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 320L-2.38419e-05 320",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 114L-2.38419e-05 114",
    stroke: "#260F05",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 0V431",
    stroke: "#260F05",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.6b2c062d2cab9c19addf7cbe36bcbd8e.svg";
export { ForwardRef as ReactComponent };